import React from 'react';
import CandidateLandingPage from 'components/Reports/CandidateLandingPage';
import { useSelector } from 'react-redux';
import useToken from 'utils/useToken';
import Auth from '../Auth';
import { AuthenticatedView } from './AuthenticatedView';

const getReduxState = (state: any) => {
  return {
    portal: state.portal,
  };
};

export const MultipleReports: React.FC = () => {
  const { portal } = useSelector(getReduxState);
  const token = useToken();

  return (
    <Auth token={token}>
      <AuthenticatedView>
        <CandidateLandingPage
          firstName={portal.firstName}
          reports={portal.reports}
        />
      </AuthenticatedView>
    </Auth>
  );
};
